import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import aboutIllustration from "../../Assets/about.png";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
import { FaMedium } from "react-icons/fa6"
import { SiGmail } from "react-icons/si";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              A little <span className="purple"> about me </span>
            </h1>
            <p className="home-about-body home-about-summary">
              Senior Software Engineer with 6+ years of experience designing, building,
              and delivering production software across backend systems, cloud
              infrastructure, and AI-powered applications. Experienced in microservice
              architecture, AWS, third-party integrations, and engineering team
              leadership, with hands-on experience integrating AI capabilities and
              building MCP-based AI integrations. Focused on AI-first engineering,
              translating business requirements into practical, reliable solutions
              through software development, system integration, and production delivery.
            </p>
            <Link to="/about" className="home-about-link">
              Read my story <span aria-hidden="true">→</span>
            </Link>
          </Col>
          <Col md={4} className="home-about-illustration">
            <img
              src={aboutIllustration}
              alt="Illustration of a developer working at a laptop"
              className="img-fluid"
              loading="lazy"
            />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h2>Let&apos;s connect</h2>
            <p>Find me online or send me a note.</p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Rehman-Akram"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/rehman-akram-1667b567"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://medium.com/@rehmanakram03"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaMedium />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="mailto:rehmanakram03@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <SiGmail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://wa.me/923334270732"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="Message Rehman on WhatsApp"
                  title="WhatsApp"
                >
                  <FaWhatsapp />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
